import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarInset } from '@/components/ui/sidebar';
import { MinimalSidebar } from '@/components/sidebars/MinimalSidebar';
import { useAuth } from '@/contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { useAdminData } from '@/hooks/useAdminData';

/**
 * PersistentAdminLayout wraps all admin routes using React Router's Outlet.
 * This ensures the sidebar and header stay mounted during navigation,
 * only re-rendering the content area (Outlet).
 */
const PersistentAdminLayout: React.FC = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();
  const adminData = useAdminData();

  useEffect(() => {
    adminData.fetchTotalCounts();
  }, []);

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  return (
    <SidebarProvider>
      <div className="flex min-h-screen w-full bg-background">
        <MinimalSidebar onSignOut={handleSignOut} />
        <SidebarInset className="flex-1">
          <Outlet />
        </SidebarInset>
      </div>
    </SidebarProvider>
  );
};

export default PersistentAdminLayout;
